<div class="select-app-container">
  <!-- Header -->
  <div class="header">
    <button class="back-button" (click)="goBack()" [disabled]="saving">
      <span class="back-icon">←</span> Back
    </button>
    <div class="header-info">
      <h1>Select Favorite App</h1>
      <p class="breadcrumb">{{ categoryName }} > {{ subCategoryName }}</p>
    </div>
  </div>

  <!-- Search Bar -->
  <div class="search-container">
    <input
      type="text"
      class="search-input"
      placeholder="Search apps..."
      [(ngModel)]="searchTerm"
      (input)="onSearchChange()"
      [disabled]="loading || saving"
    />
    <span class="search-icon">🔍</span>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <div class="spinner"></div>
    <p>Loading apps...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-state">
    <p>{{ error }}</p>
    <button class="retry-button" (click)="loadApps()">Retry</button>
  </div>

  <!-- Apps Grid -->
  <div *ngIf="!loading && !error" class="apps-grid">
    <div *ngIf="filteredApps.length === 0" class="no-apps">
      <p *ngIf="searchTerm">No apps match your search</p>
      <p *ngIf="!searchTerm">No apps available for this subcategory</p>
    </div>

    <div
      *ngFor="let app of filteredApps"
      class="app-card"
      [class.disabled]="saving"
      (click)="!saving && selectApp(app)"
    >
      <div class="app-icon-wrapper">
        <img
          [src]="getAppIcon(app)"
          [alt]="app.name"
          class="app-icon"
          (error)="handleImageError($event)"
        />
      </div>
      <div class="app-info">
        <h3 class="app-name">{{ app.name }}</h3>
        <span *ngIf="!app.active" class="inactive-badge">Inactive</span>
      </div>
      <div class="select-indicator">
        <span class="select-text">Select</span>
        <span class="select-arrow">→</span>
      </div>
    </div>
  </div>

  <!-- Saving Overlay -->
  <div *ngIf="saving" class="saving-overlay">
    <div class="saving-content">
      <div class="spinner"></div>
      <p>Saving favorite...</p>
    </div>
  </div>
</div>
